<template>
  <v-dialog
    v-model="tutorial"
    max-width="900"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        v-bind="attrs"
        v-on="on"
      >How to import</v-btn>
    </template>
    <v-sheet color="secondary">
      <v-stepper
        non-linear
        dark
        color="secondary"
      >
        <v-stepper-header>
          <v-stepper-step
            v-for="tutorialStep in tutorialContent"
            v-bind:key="tutorialStep.id"
            v-bind:step="tutorialStep.id"
            editable
          >
            {{tutorialStep.title}}
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content
            v-for="tutorialStep in tutorialContent"
            v-bind:key="tutorialStep.id"
            v-bind:step="tutorialStep.id"
          >
            <v-card>
              <v-card-title>{{tutorialStep.title}}</v-card-title>
              <v-card-text>
                {{tutorialStep.text}}
              </v-card-text>
              <v-img
                contain
                v-bind:src="require('@/assets/images/modpack-import/Arma 3 Unit Newfound Pioneer Corps Modpack step ' + tutorialStep.id + '.webp')"
                v-bind:alt="'Arma 3 Unit Newfound Pioneer Corps Modpack step' + tutorialStep.id"
              >

              </v-img>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-btn
        block
        text
        color="primary"
        v-on:click="tutorial = false"
      >
        got it
      </v-btn>
    </v-sheet>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      tutorial: false,
      tutorialContent: [
        {
          id: 1,
          title: "Download modpack html",
          text: "Download the modpack as an html file."
        },
        {
          id: 2,
          title: "Open launcher",
          text: "Within the arma launcher, select \"MODS\", then \"PRESET\", and finally \"Import\"."
        },
        {
          id: 3,
          title: "Import preset",
          text: "Select the file you downloaded in step 1."
        },
        {
          id: 4,
          title: "Save preset",
          text: "Finally, click \"SAVE AS..\" and give it a name so you can reuse your modpack preset."
        }
      ]
    };
  },
};
</script>

<style>
</style>
